import { GraphQLCampaign } from 'modules/campaigns/lib/types';

export const getAbortCampaignPayload = (campaign: GraphQLCampaign) => {
  const { id: campaignId } = campaign;

  return {
    campaignId,
  };
};
